import * as apiGetSettingKey from 'api/setting/GetSettingV1';
import { ReducerBuilder } from 'reducers/ReducerBuilder';
import { payloadReducer } from 'reducers/reducerUtils';
import { defaultSettingDto } from 'types/Setting/Setting';

export type QuantityMethod = string;

export async function getQuantityMethod(): Promise<QuantityMethod> {
	const response = await apiGetSettingKey.callApi();
	return response.getOrDefault(defaultSettingDto()).calculationSettings.quantityMethod;
}

const rb = new ReducerBuilder<QuantityMethod>();
export const quantityMethodLoadedAction = rb.createActionForReducer(
	payloadReducer((x) => x),
	'QuantityMethod/LoadedFromBackend'
);

export const quantityMethodReducer = rb.createReducer();
